var symphony = symphony || {};

;
(function () {
    symphony.thermometerTimers = [];
    symphony.getThermometer = function ($container, goal, raised, endDate, donateButtonTxt, donateUrl) {
        if (!symphony || !symphony.strings || !Handlebars.helpers['getSymphonyString']) {
            setTimeout(function() {
                symphony.getThermometer($container, goal, raised, endDate, donateButtonTxt, donateUrl);
            }, 1000);
            return;
        }

        var timer;
        var existingTimer = $.grep(symphony.thermometerTimers, function (t) {
            return t.id == $container.attr('id');
        })[0];
        if (existingTimer != null) {
            symphony.thermometerTimers = $.grep(symphony.thermometerTimers, function (t) {
                return t.id !== $container.attr('id');
            });
            clearInterval(existingTimer.timer);
        }
        var percent;

        goal = goal ? goal : 0;
        endDate = endDate ? endDate : new Date();
        raised = raised ? raised : 0;
        percent = raised ? ((raised) / (goal) * 100).toFixed(0) + '%' : 0 + '%';

        function renderThermometer($container) {
            if ($container.find(".fundraisingThermometer-progress").length > 0) {
                $container.find(".fundraisingThermometer-progress")[0].style.width = percent;
                CountDownTimer(endDate, $container);

                function CountDownTimer(dt, $container) {
                    var end = new Date(dt);

                    var _second = 1000;
                    var _minute = _second * 60;
                    var _hour = _minute * 60;
                    var _day = _hour * 24;

                    function showRemaining($container) {
                        var now = new Date();

                        var distance = end - now;
                        if (distance < 0) {

                            $container.find('.fundraisingThermometer-countdown').html('0');

                            return;
                        }
                        var days = Math.floor(distance / _day);
                        var hours = Math.floor((distance % _day) / _hour);
                        var minutes = Math.floor((distance % _hour) / _minute);
                        var seconds = Math.floor((distance % _minute) / _second);

                        var timeLeft = '';
                        if (Number(days) > 0) {
                            timeLeft += days;
                            $container.find('.fundraisingThermometer-time-label').html(days > 1 ? symphony.strings['layout.daysToGo'] : symphony.strings['layout.dayToGo'])
                        } else {
                            if (hours > 0) {
                                timeLeft += hours + ' hr' + (hours > 1 ? 's' : '') + ' ';
                            }
                            if (minutes > 0) {
                                timeLeft += minutes + ' min' + (minutes > 1 ? 's' : '') + ' ';
                            }
                            if (seconds > 0) {
                                timeLeft += seconds + ' sec' + (seconds > 1 ? 's' : '');
                            }
                            $container.find('.fundraisingThermometer-time-label').html(symphony.strings['layout.timeRemaining']);
                        }
                        $container.find('.fundraisingThermometer-countdown').html(timeLeft);
                    }

                    timer = setInterval(function () {
                        showRemaining($container)
                    }, 1000);
                    symphony.thermometerTimers.push({
                        id: $container.attr('id'),
                        timer: timer
                    });
                }
            }
        }

        function addComma(num) {
            var num_parts = num.toString().split(".");
            num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return num_parts.join(".");
        }

        setTimeout(function () {
            renderThermometer($container);
        }, 300);

        $container.html(symphony.templates['thermometer']({
            goal: addComma(goal),
            raised: addComma(raised),
            percent: percent,
            donateButtonTxt: donateButtonTxt,
            donateUrl: donateUrl
        }))
    };

})();
